import writeXlsxFile from "write-excel-file";
import { getQuotasConvention } from "../../../../utils/services/quotas";
import moment from "moment/moment";

export async function quotasSelectedsXlsx({
  jwt,
  offset,
  limit,
  totalItems,
  setFinishExport,
  type,
}) {
  const formatDate = (date) => {
    const dateMoment = moment(new Date(date)).format();

    const dateFormat = dateMoment.split("T")[0].split("-").reverse().join("/");
    const time = dateMoment.split("T")[1].slice(0, 8);
    return `${dateFormat} - ${time}`;
  };

  const schema = [
    {
      column: "Login ID",
      type: String,
      value: (e) => e.loginId,
    },
    {
      column: "Email",
      type: String,
      value: (e) => e.email,
    },
    {
      column: "Nome",
      type: String,
      value: (e) => e.nome,
    },
    {
      column: "Empresa",
      type: String,
      value: (e) => e.empresa,
    },
    {
      column: "Data / Hora",
      type: String,
      value: (e) => formatDate(e.createdAt),
    },
    {
      column: "Cota ID",
      type: String,
      value: (e) => e.convencaoSegurosCotasId,
    },
  ];

  const allRequestsPromises = [];
  const numberOfRequisitions = Math.ceil(totalItems / limit);

  for (let i = 1; i <= numberOfRequisitions; i += 1) {
    const request = await getQuotasConvention(jwt, offset, limit, type);
    allRequestsPromises.push(request);
    setTimeout(() => {}, 500);

    const progressBar = document.querySelector(".export-progress");
    const percentageBar = document.querySelector(".export-percentage");

    progressBar.style.width = `${(i / numberOfRequisitions) * 100}%`;
    percentageBar.innerHTML = `${((i / numberOfRequisitions) * 100).toFixed(
      0
    )}%`;

    if (i === numberOfRequisitions) {
      setTimeout(() => {
        setFinishExport(true);
      }, 1000);
    }
  }
  const allDataInSingleArray = allRequestsPromises.map((e) => e.data).flat();

  if (allDataInSingleArray) {
    await writeXlsxFile(allDataInSingleArray, {
      schema,
      fileName: "cotasSelecionadas.xlsx",
    });
  }
}
